import React from 'react'
import { SectionTitleSkeleton } from '@diversioteam/diversio-ds'
import { Skeleton } from '@material-ui/lab'

import * as S from './../publishedStatus.styles'

export const PublishedStatusSkeleton = () => {
    return (
        <S.PublishedStatusWrapper>
            <S.Header>
                <SectionTitleSkeleton />
            </S.Header>

            <S.DateInfo>
                <span>
                    <Skeleton width={80} />
                </span>

                <span>
                    <Skeleton width={100} />
                </span>
            </S.DateInfo>
        </S.PublishedStatusWrapper>
    )
}
